<template>
    <div>
        <div class="page">
            <div  class="body"  >
                <van-skeleton title avatar :row="8" :loading="loading_detail" style="padding:20px;" > 
                    <div class="my-task" style="border:0">
                        <div class="my-task-center">
                            <div class="task-user-logo">
                                <img :src="reply_detail.photo" binderror="errorMyWorkImage" />
                            </div>
                            <div class="task-user-content">
                                <div class="task-user-info">
                                    <div class="task-user-name">
                                        {{reply_detail.user_name}}
                                    </div>
                                </div>

                                <div class="task-user-answer">
                                    <div class="task-user-txt" v-text="reply_detail.content" style="white-space: pre-wrap;" ></div>
                                    <div class="task-user-img" v-if="reply_detail.res_type == 1">
                                        <div class="my-gallery">
                                            <div @click="previewImg(reply_detail.res_datas,index)" v-for="(item,index) in  reply_detail.res_datas" :key="index" >
                                                <img :src="item" mode="heightFix" v-if="reply_detail.res_datas.length==1" style="height:48vw" />
                                                <img :src="item" mode="aspectFill" v-if="reply_detail.res_datas.length>1" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="task-user-btn">
                                        <div class="task-user-time">
                                            {{reply_detail.create_date}}
                                        </div>
                                        <div class="task-message-btn" >
                                            <span class="iconfont iconxiaoxi2" @click="handleProxy(reply_detail)" ></span>
                                            <span class="favor-cnt">{{reply_detail.reply_count}}</span>
                                        </div>
                                        <div class="task-info-love" @click="favorSave(reply_detail)">
                                            <span class="iconfont iconaixin1" :style="{'color': reply_detail.is_favor?'#f30':'#8a8a8a'}"></span>
                                            <span class="favor-cnt">{{reply_detail.favor_count}}</span>
                                        </div>
                                        <div class="task-shares-user" @click="handShare(reply_detail)">
                                            <span class="iconfont iconiconfontzhizuobiaozhun20"></span>
                                        </div>

                                    </div>
                                    <div class="ca-item" v-if="reply_detail.favors && reply_detail.favors.length>0">
                                        <span class="iconfont iconaixin" style="color:#f30;font-size: 12px"></span>
                                        <span v-for="(item_fav, index_fav) in reply_detail.favors" :key="index_fav" style="color: #71a3ae;font-size: 12px">
                                            {{index_fav==0?item_fav.user_name:'，'+item_fav.user_name}}
                                        </span>
                                        <span v-if="reply_detail.favors.length>2">等{{reply_detail.favor_cnt}}人赞过</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="task-course" v-if="reply_detail.course_id">
                        <div class="task-course-tip">相关课程</div>
                        <div class="task-course-col" @click="bindGoToCurriculum(reply_detail.course_id)">
                            <!--<image src="{{msgWork.course_cover}}"/>-->
                            <div class="task-course-name">
                                {{reply_detail.course_name}}
                            </div>
                        </div>
                    </div>
                </van-skeleton>

                <div style="text-align:center">
                    <div class="msg-h1">全部回复</div>
                </div>
                <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                >
                    <div class="task-dynamic-center" v-for="(item,index) in reply_list" :key="index">
                        <div class="task-user-logo">
                            <img :src="item.user_photo" :data-index="index"
                                binderror="errorImageFunction" />
                        </div>
                        <div class="task-user-content">
                            <div class="task-user-info">
                                <div class="task-user-name">
                                    {{item.user_name}}
                                </div>
                            </div>
                            <div class="task-user-answer">
                                <div class="task-user-txt">
                                    {{item.reply_content}}
                                    <span v-if="item.to_reply_content">
                                        <span style="margin:0 5px;color:#ccc">//@{{item.to_user_name}}:</span>
                                        {{item.to_reply_content}}
                                    </span>
                                </div>
                                <div class="task-user-btn">
                                    <div class="task-user-time">
                                        {{item.create_date}}
                                    </div>
                                    <div class="task-message-btn" @click="handleProxy(item)" :data-user_name="item.user_name"
                                        :data-work_reply_id="item.work_reply_id"
                                        >
                                        <span class="iconfont iconxiaoxi2"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
                
            </div>
        </div>

        <!--回复窗口-->
        <div class="send-chat" :style="'bottom:'+chatBottom+'px'" v-if="isChat">
            <input
                    :placeholder="MsgPlaceholder"
                    @focus="getChatBottom"
                    @blur="setChatBottom"
                    @keyup.enter="sendMsg"
                    @input="setMsgDetail"
                    ref="getFocus"
                    v-model="MsgValue" 
                    type="text"
            />
            <div class="btn-send" @click="sendMsg">发送</div>
        </div>

        <!-- 海报相关 TODO -->
        <div v-if="share_display" class="haibao-container">
            <div>
                <div class="haibao-container-tip" >
                    <van-icon name="close" style="float: right;padding-right:5px;" size="18px" @click="handCloseShare" />
                    <span style="clear:both" >长按保存图片分享至朋友圈吧~</span>
                </div>
                <div class="haibao-container-img">
                    <img :src="share_images" alt="">
                </div>
                <div class="haibao-container-next">
                    <span class="iconfont iconxiala1"></span>
                </div>
            </div>
        </div>
        <div id="haibao-container" class="haibao-container">
            <div class="haibao-container-top">
                <div class="haibao-contents">
                    <div id="haibao-contents-create" class="haibao-contents-t">
                        <div class="haibao-header">
                          <div class="haibao-header-content">
                            <div class="header-title">今日分享</div>
                            <div class="header-user">
                                <img class="header-user-photo" :src="share_info.author_photo+'?x-oss-process=image/format,jpg'" >
                                <div class="header-user-userzone">
                                      <div class="header-user-username">{{share_info.author}}</div>
                                      <div class="header-user-tips">发布于 {{share_info.create_time_cn}}</div>
                                </div>
                            </div>
                            <div  v-text="share_info.content" class="haibao-contents-text"></div>
                          </div>
                        </div>
                        <div class="haibao-center-tips" >扫码去互动吧</div>
                        <div  class="haibao-footer">
                          <div class="haibao-footer-user-zone">
                            <div>
                              <div class="user-zone-username">{{share_info.user_name}}</div>
                              <div class="user-zone-desc">我在【星辰大讲堂】发现精彩话题, 扫码和我一起<span class="font-color-orange">免费讨论</span></div>
                            </div>
                            <div ><qrcode-vue class="user-zone-qr" :value="share_info.qr_code" size="60" level="H"></qrcode-vue></div>
                          </div>
                          <div class="train_zone">
                            <img class="train_logo" :src="share_info.train_logo" >
                            <div class="train_name">{{share_info.train_name}}</div>
                          </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        


    </div>
</template>
<script>
    var audioInterval,duration_time_Interval;
    var WeChat;
    import { Skeleton,Slider,Tab,Button,Tabs,Lazyload,Field,Icon,Image as VanImage ,Swipe, SwipeItem,List,ImagePreview,Empty,Popup,NavBar,Uploader} from 'vant';
    import share from '../../components/common/share';
    import env from '../../utils/env'
    import html2canvas from "html2canvas";
    import QrcodeVue from "qrcode.vue";
    import {util} from '@/utils/util'
    // import VConsole from "vconsole";
    // var vConsole = new VConsole();

    export default {
        name: "detail",
        components:{
            [Slider.name]:Slider,
            [Tab.name]:Tab,
            [Tabs.name]:Tabs,
            [VanImage.name]:VanImage,
            [Swipe.name]: Swipe,
            [Icon.name]:Icon,
            [SwipeItem.name]: SwipeItem,
            [List.name]:List,
            [Empty.name]:Empty,
            share,
            [Field.name]:Field,
            [Popup.name]:Popup,
            [Button.name]:Button,
            [NavBar.name]:NavBar,
            [Uploader.name]:Uploader,
            [Skeleton.name]:Skeleton,
            QrcodeVue
        },
        data(){
            return {
                loading_detail:true,
                loading_list:true,
                course_reply_id: "", //删除
                work_answer_id: "",
                reply_detail:{},
                page:1,
                pageSize:10,
                reply_list: [],
                loading: false,
                finished: false,
                isChat: false,
                chatBottom: 0,
                MsgValue: "",
                currItem: "",
                MsgPlaceholder: "回复",
                share_display: 0, //是否显示海报
                share_images: "", //海报生成的图
                share_info: {
                    head_images: "",
                    content: "",
                    author: "",
                    author_photo: "",
                    user_photo: "",
                    user_name: "",
                    course_name: "示例",
                    day: "01",
                    date: "2020.11",
                    qr_code: "",
                    train_name: "星辰大讲堂",
                    train_logo: "http://yun-yzx.oss-cn-shenzhen.aliyuncs.com/train/1603792660-9680.png",
                },
                share_default_images1: [
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_1.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_2.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_3.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_5.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_6.png",
                ],
                share_default_images: [
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8991702.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8a6c7a1.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8b6c153.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8c4ddc6.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8d09bb4.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8dcdad2.jpg",
                ]
            }
        },
        beforeRouteLeave(to, from, next){
            if(to.name == 'curriculum/index') {
                to.meta.keepAlive = true;
            }
            next()
        },
        activated() {
            
        },
        mounted() {
            this.work_answer_id = this.util.getQueryStr('work_answer_id');
            this.init();
            
            console.log('this.util.globalData.user.get()',this.util.globalData.user.get())
            if(this.util.globalData.user.get() == '' && this.util.sessionid.get() != '' ){
                this.util.server.mini_user.info({
                    callback: (res => {
                        this.util.globalData.user.set(res.data);
                        this.util.getUserId.set(res.data.user_id);
                        this.util.user_mobile.set(res.data.mobile);
                        this.user=this.util.globalData.user.get();
                    })
                })
            }
        },
        methods:{
            init(){
                this.getAnswerDetail()
                this.getReplyReplyList()
            },
            onLoad(){
                //this.getReplyReplyList()
            },
            bindGoToCurriculum(course_id){
                this.$router.push(this.util.urlPrefix+'/curriculum/index?&course_id='+course_id+'&token='+this.util.token);
            },
            getAnswerDetail(){
                const _self = this
                this.util.server.mini_work.answer_detail({
                    data: {
                        work_answer_id: this.work_answer_id,
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1) {
                            _self.loading_detail = false
                            _self.reply_detail = data
                            _self.reply_detail.work_answer_id = _self.work_answer_id
                            //_self.handShare(_self.reply_detail)
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            getReplyReplyList(){
                const _self = this
                this.util.server.mini_work.reply_list({
                    data: {
                        work_answer_id: this.work_answer_id,
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1) {
                            _self.reply_list = _self.reply_list.concat(data.items)
                            _self.page ++
                            _self.loading = false
                            _self.loading_list = false
                            if(_self.reply_list.length >= data.total){
                                _self.finished = true;
                            }
                            
                        }else{
                            _self.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
          },
          handleProxy(item){
                this.isChat = true
                this.MsgPlaceholder = "回复 "+item.user_name
                this.currItem = item
          },
          //获取输入法高度
          getChatBottom:function(e){
              this.chatBottom = e.target.height || 0;

          },
          //初始化留言bottom
          setChatBottom:function(){
              this.chatBottom=0;
          },
          //发送留言
          sendMsg:function(e){
              var val = this.MsgValue.replace(/\s+/g, '');
              var _self=this;
              if(val == ''){
                  return this.util.showToast({
                      message:'回复内容不能为空'
                  });
              }
              console.log("this.currItem ",this.currItem )

              this.util.server.mini_work.reply({
                  data:{
                      work_answer_id: this.currItem.work_answer_id,
                      to_work_reply_id: this.currItem.work_reply_id,
                      reply_content:val
                  },
                  callback:(res=>{
                      const { code, data, msg } = res;
                      if(code==1){
                          this.reply_list.unshift(data)
                          this.currItem = ""
                          this.MsgValue = ""
                          this.isChat = false
                          //重新加载
                          // _self.reply_list = [];
                          // _self.page = 1;
                          // _self.getReplyReplyList()
                      }
                      

                      console.log(code, this.reply_list)
                      
                  })
              })
          },
          setMsgDetail:function(e){
                //var val = e.target.value;
                //this.MsgValue = val;
                console.log(this.MsgValue);
          },
          //点赞
          favorSave:function(item){
              const _self = this
              console.log("item,",item)
              this.currItem = item
              this.util.server.mini_work.favor({
                  data:{
                      work_answer_id: this.work_answer_id,
                  },
                  callback:(res=>{
                      const { code, data, msg } = res;
                      _self.reply_detail.is_favor = data.is_favor
                      if(data.is_favor==1){
                        _self.reply_detail.favor_count++
                      }else{
                        _self.reply_detail.favor_count--
                      }

                      var favor_list = [];
                        if(data.is_favor){
                            var param = {
                                user_id: this.util.getUserId.get(),
                                user_name: data.user_name
                            };
                            favor_list = _self.reply_detail.favors;
                            favor_list.push(param);
                        }else{
                            for (var i =0;i<_self.reply_detail.favors.length;i++){
                                var tempItem = _self.reply_detail.favors[i];
                                if(tempItem.user_id == this.util.getUserId.get()){
                                    continue;
                                }
                                favor_list.push(tempItem)
                            }
                        }
                        
                        _self.reply_detail.favors = favor_list
                      
                  })
              })
          },
          handShare(item){
                const _this = this
                console.log('item',item)
                const userinfo = this.util.globalData.user.get()
                console.log('分享本地用户','userinfo', userinfo)
                
                this.share_info.content = item.content
                this.share_info.author = item.user_name
                this.share_info.author_photo = item.photo
                this.share_info.user_photo = userinfo.photo
                
                this.share_info.user_name = userinfo.user_name
                this.share_info.course_name = item.course_name 
                this.share_info.create_time_cn = item.create_time_cn

                this.share_info.train_name = util.G_CONFIG.train_name
                this.share_info.train_logo = util.G_CONFIG.logo
                //return false
                
                let mydate = new Date()
                this.share_info.day = mydate.getDate()
                this.share_info.date = mydate.getFullYear()+'.'+ (mydate.getMonth()+1)


                //如果有则使用上传的，否则使用系统默认
                if(item.res_datas && item.res_datas.length>0 && 0){
                    this.share_info.head_images = item.res_datas[0]
                }else{
                    const len = this.share_default_images.length
                    const index = Math.floor((Math.random()*len))
                    this.share_info.head_images = this.share_default_images[index]
                }
                // this.share_info.head_images = 'https://o-yzx.bysjy.com.cn/common/poster_bg_1.png'
                this.share_info.qr_code = window.location.origin+this.util.urlPrefix+'/course_task/answer_detail?work_answer_id='+item.work_answer_id+'&token='+this.util.token
                console.log('this.share_info', this.share_info)
                this.$nextTick(() => {
                    

                    let content_html = document.getElementById("haibao-contents-create"); //要转化的div
                    const _this = this;
                    let width = content_html.offsetWidth;
                    let height = content_html.offsetHeight;
                    let offsetTop = content_html.offsetTop;
                    let canvas = document.createElement("canvas");
                    let context = canvas.getContext("2d");
                    let scaleBy = Math.ceil(window.devicePixelRatio);
                    canvas.width = width * scaleBy;
                    canvas.height = (height + offsetTop) * scaleBy;
                    context.scale(scaleBy, scaleBy);

                    let offSetScrollTop = document.body.scrollTop || document.documentElement.scrollTop;

                    var opts = {
                        useCORS: true, //允许加载跨域的图片
                        tainttest: true, //检测每张图片都已经加载完成
                        scale: scaleBy, // 添加的scale 参数
                        canvas: canvas, //自定义 canvas
                        logging: false, //日志开关，发布的时候记得改成false
                        width: width, //dom 原始宽度
                        height: height, //dom 原始高度
                        backgroundColor: null,
                        scrollY: 0,
                    };
                    if (content_html) {
                        // html2canvas(content_html, {scale:2,logging:false,useCORS:true,backgroundColor: null,dpi: window.devicePixelRatio * 2}).then(function(canvas) {
                        html2canvas(content_html, opts).then(function(canvas) {
                        // canvas.getContext("2d").translate(-20,30);
                            _this.$nextTick(() => {
                                //let mCircle = document.getElementById("change-punch-haibao-icon");
                                // if (mCircle !== null) {
                                // mCircle.classList.remove("change-punch-haibao-icon-active");
                                // }
                                _this.share_display = 1
                                var url = canvas.toDataURL();
                                console.log("图片生成中...")
                                _this.share_images = url;
                            });
                            // const dataUrl = canvas.toDataURL();
                            // _this.mImgSrc = dataUrl;
                            // // _this.uploadShareImg(dataUrl);
                            // // _this.$emit('addUserScore',2)
                            // _this.$emit("uploadShareImg", dataUrl);

                            
                        });
                    }

                    
                });
                
            },
            handCloseShare(){
              this.share_display = 0
            },
        }
    }
</script>

<style scoped>
.my-task{
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    margin: 0 0 -1px -1px;

    padding: 10px;
    box-sizing: border-box;
}
.my-task .my-task-title{
    padding-bottom: 2px;
    border-bottom: 3px solid #666;
    width: 90px;
    font-weight: bold;
}
.my-task .my-task-center{
    margin-bottom: 10px;
    position: relative;
}
.task-user-logo{
    width: 40px;
    font-size: 0;
    position: absolute;
    top: 0;
}
.task-user-logo img{
    width: 40px;
    height: 40px;
    border-radius: 20px;
}
.task-user-content{
    display: inline-block;
    width: 100%;
    padding-left: 50px;
    box-sizing: border-box;
}
.task-user-info{
    position: relative;
    height: 40px;
    line-height: 40px;
}
.task-user-info .task-user-name{
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.task-user-info .task-edit{
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    text-align: center;
    color: #4395ff;
}
.task-user-answer .task-user-img{
    overflow: hidden;
    margin-top: 15px;
    font-size: 0;
}
/*.task-user-answer .task-user-img image{*/
    /*width: 40px;*/
    /*height: 40px;*/
    /*border-radius: 10px;*/
    /*margin-right: 10px;*/
    /*margin-bottom: 10px;*/
/*}*/
.task-user-answer .task-user-txt{
    margin: 10px 0;
}
.task-user-btn{
    display: flex;
}
.task-user-btn .task-user-time{
    font-size: 12px;
    color: #aaa;
    flex: 1;
}
.task-user-btn .task-message-btn{
    width: 40px;
    text-align: center;
}
.task-user-btn .task-info-love{
    text-align: center;
    min-width: 40px;
}
.task-user-btn .task-shares-user{
    width: 40px;
    text-align: center;
}
.task-user-btn .iconfont{
    color: #8a8a8a;
    font-size: 20px;
}
.task-dynamic{
    padding: 10px;
}
.task-dynamic-title{
    padding-bottom: 2px;
    border-bottom: 3px solid #666;
    width: 90px;
    font-weight: bold;
}
.task-dynamic-center{
    margin: 10px 0;
    position: relative;

    padding: 10px;
    box-sizing: border-box;
}
.comment-area{
    background: #f5f5f5;
    border-radius: 4px;
    margin-top: 5px;
    padding: 5px 0;
    margin-bottom: 5px;
    position: relative;
}
.comment-area::before{
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-color: transparent transparent #f5f5f5 transparent;
    border-top-width: 0;
    top: -8px;
    left: 20px;
}
.comment-area .ca-item{
    padding: 0 5px;
    position: relative;
    padding-bottom: 3px;
}
.task-dynamic .task-dynamic-center:last-child{
    margin-bottom: 41px;
}
.pub-orange-text{
    color: #ff9234;
}
.ca-whole-item{
    font-size: 12px;
    padding: 0 5px;
    color: #4395ff;
    padding-top: 5px;
}
.ca-whole-item .iconfont{
    vertical-align: middle;
}
.edit-task{
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: 100%;
    border-top: 1px solid #ccc;
    text-align: center;
    padding: 10px 0;
}
.pub-user-text{
    color: #71a3ae;
}
.send-chat{
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 5px;
    background-color: #fff;
    box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    z-index: 99999;
    max-width: 480px;
    left: 0;
    right: 0;
    margin: 0 auto;
}
.send-chat input{
    padding: 5px;
    background-color: #f3f3f3;
    padding-right: 47px;
}
.chat-content .chat-details{
    width: 100%;
    height: 100%;
    padding: 10px;
    /*overflow-y: auto;*/
    box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
.send-chat .btn-send{
    position: absolute;
    top: 0;
    right: 0;
    /* height: 1.4rem; */
    margin-right: 5px;
    margin-top: 5px;
    padding: 5px;
    /* line-height: 1.4rem; */
    letter-spacing: 2px;
    border-left: 1px solid #ccc;
}
.mag-list{
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    transition:all .2s ease-in-out;
    opacity:0;
    visibility:hidden
}
.i-as-mask-show{
    opacity:1;
    visibility:visible
}
.mag-list .msg-content{
    height: 90%;
    width: 100%;
    position: absolute;
    background-color: #ffffff;
    transform:translate3d(0,100%,0);
    transform-origin:center;
    transition:all .2s ease-in-out;
    top: 10%;
    visibility:hidden;
    z-index: 10;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    padding: 0 15px;
    box-sizing: border-box;
}
.mag-list .i-as-show{
    transform:translate3d(0,0,0);
    visibility:visible
}
.msg-header .msg-header-txt{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 10px 0;
    border-bottom: 1px solid #ccc;
    position: relative;
}
.msg-header-txt .icon{
    position: absolute;
    right: 0;
    top: 10px;
}
.msg-h1{
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    position: relative;
    display: inline-block;
}
.msg-h1:after,.msg-h1:before{
    content: '';
    position: absolute;
    height: 2px;
    width: 30px;
    background-color: #ccc;
    top: 50%;
    border-radius: 2px;
}
.msg-h1:before{
    left: -40px;
}
.msg-h1:after{
    right: -40px;
}
.no-list{
    text-align: center;
    width: 100%;
    margin: 10px 0;
    color: #999;
    font-size: 12px;
}
.favor-cnt{
    font-size: 12px;
    padding-left: 5px;
    vertical-align: middle;
}
.task-info-love .iconaixin1{
    vertical-align: middle;
}
.task-message-btn .iconxiaoxi2{
    vertical-align: middle;
}
.body{
    background-color: #fff;
    display: flex;
    flex: 1;
    flex-direction: column;
}
.send-chat{
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 5px;
    background-color: #fff;
    box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    z-index: 99999;
}
.send-chat input{
    padding: 5px;
    background-color: #f3f3f3;
    padding-right: 47px;
    border: 0;
    width: 100%;
    height: 32.39px;
    box-sizing: border-box;
}
.chat-content .chat-details{
    width: 100%;
    height: 100%;
    padding: 10px;
    /*overflow-y: auto;*/
    box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
.page{
    height: 100%;
    background-color: #fff;
    display: flex;
    flex: 1;
    flex-direction: column;
}
.my-gallery{
    width: 100%;
    float: left;
}
.my-gallery div{
    display: block;
    float: left;
    margin: 0 2px 2px 0;
}
.my-gallery div img{
    width: 24vw;
    height: 24vw;
    display: block;
    object-fit: cover;
}
.share-temp-img{
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    text-align: center;
    z-index: 9999;
}
.temp-title{
    color: #fff;
    margin-top: 5%;
    width: 100%;
    position: absolute;
    font-weight: bold;
}
.temp-file-img{
    width: 300px;
    height: 360px;
    margin-top: 5%;
}
.temp-close{
    position: fixed;
    text-align: center;
    width: 100%;
    bottom: 5%;
}
.task-course{
    border-top: 1px solid #eee;
    margin-bottom: 10px;
    padding: 10px;
    border-bottom: 3px solid #eee;
}
.task-course-col{
    background-color: #f8f9fb;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    margin-top: 10px;
}
.task-course-tip{
    color: #555;
}
/* TODO */
#haibao-container{
    position: fixed;
    left: -9999px;
    top: -9999px; 
    /* left: 0px;
    top: 0px; */
}
.haibao-container{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0,0,0,.66);
    z-index: 999;
    padding-top: 35px;
    box-sizing: border-box;
}
.haibao-container-tip{
    text-align: center;
    color: #FFF;
    padding: 5px;
}
.haibao-container-img{
    padding: 0px 10px;
    overflow-y:auto;
    height: calc(100vh - 80px);
}
.haibao-container-img img{
    width: 100%;
}
.haibao-container-next{
    text-align: center;
    font-size: 20px;
    position: absolute;
    bottom: 18px;
    width: 100%;
}
.haibao-container-top{
    width: 100%;
}
.haibao-contents{
    padding: 10px 10px 0;
    box-sizing: border-box;
    position: relative;
}
.haibao-contents-t{
    padding: 0;
    box-sizing: border-box;
    background: white;
}
.haibao-contents-headimg{
    width: 100%;
    height: 200px;
    display: block;
}
.haibao-contents-wrap{
    background: white;
    min-height: calc(100vh - 370px);
    font-size: 16px;
    padding: 20px 20px 120px;
    position: relative;
}
.haibao-contents-author{
    text-align: right;
    padding-top: 20px;
}
.haibao-contents-qr-wrap{
    position: absolute;
    width: calc(100vw - 60px);
    bottom: 20px;
    height: 80px;
    display: flex;
    justify-content: space-between;
}
.haibao-contents-qr-left{
    display: flex;
    justify-content: space-between;
}
.haibao-contents-qr-head{
    width: 60px;
    height: 60px;
    border-radius: 30px;
}
.haibao-contents-qr-userzone{
    padding-left: 10px;
    flex: 1;
}
.haibaoq-qr-username{
    font-weight: 600;
    font-size: 11px;
}
.haibaoq-qr-tips{
    font-size: 11px;
}
.haibaoq-qr-course{
    color: tomato;
}
.haibao-contents-qr-right{
    width: 60px;
    text-align: center;
}
.haibao-contents-qr-code{
    width: 40px;
    height: 40px;
}
.haibao-contents-qr-guide{
    font-size: 11px;
}
.baibao-date{
    text-align: right;
    position: absolute;
    z-index: 999;
    text-align: right;
    width: 100%;
    bottom: 0px;
    background: rgba(90, 87, 87, 0.5);
    color: #f9f7f5;
}

.haibao-header{
    background-image: url("https://o-yzx.bysjy.com.cn/share/template.png");
    padding: 10px 10px 0px 10px;
    
}
.haibao-header-content{
  padding: 10px;
  background:white;
}
.header-title{
  background: #ececec;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  font-weight: 600;
  padding-left: 10px;
}
.header-user{
  margin-top: 25px;
  display: flex;
}
.header-user-photo{
  width: 40px;
  height: 40px;
  border-radius: 25px;
}
.header-user-userzone{
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.header-user-username{
  font-weight: 600;
  font-size: 14px;
  color: #5d5252;
}
.header-user-tips{
  font-size: 12px;
  color:#aaa;
}
.haibao-contents-text{
  white-space: pre-wrap;
  margin-top: 15px;
  min-height: 300px;
}
.haibao-center-tips{
  text-align: center;
  font-size: 12px;
  color: #aaa;
}
.font-color-orange{
  color: orange;
}
.haibao-footer{
  padding: 20px 20px 0px 20px;
}
.haibao-footer-user-zone{
  display: flex;
}
.user-zone-username{
  font-size: 15px;
  font-weight: 600;
}
.user-zone-desc{
  margin-top: 5px;
  padding-right: 5px;
  font-size: 13px;
}
.user-zone-qr{
  /* margin-top: 10px; */
}
.train_zone{
  display: flex;
  justify-content: center;
}
.train_logo{
  height: 35px;
}
.train_name{
  margin-left: 5px;
  font-size: 13px;
  color: #aaa;
  line-height: 40px;
}
</style>